/**
 * Temporary workaround:
 * Since API takes for ASC sorting param "+" param and angular has issues resolving this (https://github.com/angular/angular/issues/18261)
 * We need this temporary workaround until upper mentioned issues has been fiexed or API has changed.
 * 
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent, HttpParameterCodec
} from '@angular/common/http';


import { Observable } from 'rxjs/Observable';
import { Configuration, BASE_PATH, CARDINFO } from '../../../../gen/swagger-api';
import {CustomHttpUrlEncodingCodec} from "../../../../gen/swagger-api/encoder";



class CustomEncoder implements HttpParameterCodec {
    encodeKey(key: string): string {
        return encodeURIComponent(key);
    }

    encodeValue(value: string): string {
        var value = encodeURIComponent(value);
        value = value.replace("%2B", "+")
        return value;
    }

    decodeKey(key: string): string {
        return decodeURIComponent(key);
    }

    decodeValue(value: string): string {
        return decodeURIComponent(value);
    }
}


@Injectable()
export class DefaultServiceGetCards {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


  /**
   *
   * Card list getting operation. This is the operation to get a list of cards managed by the authenticated account
   * @param offset An offset for a list (required for pagination)
   * @param limit A maximum number of entries returned by the request
   * @param searchString Search for cards with given EID, ICCID, MSISDN or IMEI
   * @param cardGroupId Filter records by present group Id
   * @param poolId Filter records by present pool Id
   * @param mnoId Filter records by present mno Id
   * @param numberOfSubscriptions Filter records by the number of subscriptions present
   * @param status Filter record by status of the card
   * @param sortString The string that defines the sorting. It has the following form XYYYYYY, XYYYYYYY. X - sort order. if x - &#39;-&#39; then descending, if x - &#39;+&#39;, then ascending. Y - name of the field by which the records are sorted. Available values for Y  - imsi,  - iccid,  - msisdn,  - mno_id,  - group_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CARDINFO>>;
  public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CARDINFO>>>;
  public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CARDINFO>>>;
  public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (offset !== undefined) {
      queryParameters = queryParameters.set('offset', <any>offset);
    }
    if (limit !== undefined) {
      queryParameters = queryParameters.set('limit', <any>limit);
    }
    if (searchString !== undefined) {
      queryParameters = queryParameters.set('search_string', <any>searchString);
    }
    if (cardGroupId) {
      cardGroupId.forEach((element) => {
        queryParameters = queryParameters.append('card_group_id', <any>element);
      })
    }
    if (poolId) {
      poolId.forEach((element) => {
        queryParameters = queryParameters.append('pool_id', <any>element);
      })
    }
    if (mnoId) {
      mnoId.forEach((element) => {
        queryParameters = queryParameters.append('mno_id', <any>element);
      })
    }
    if (numberOfSubscriptions) {
      numberOfSubscriptions.forEach((element) => {
        queryParameters = queryParameters.append('number_of_subscriptions', <any>element);
      })
    }
    if (status) {
      status.forEach((element) => {
        queryParameters = queryParameters.append('status', <any>element);
      })
    }
    if (sortString !== undefined) {
      queryParameters = queryParameters.set('sort_string', <any>sortString);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<CARDINFO>>(`${this.basePath}/cards`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/workaround/default-service-get-cards.service.ts